module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chaptertitle"
  }, [_c('a', {
    attrs: {
      "id": "p5"
    }
  }), _vm._v(" DeDe Vecchio's Sturgis Farmer's Omelet")]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("This road recipe is from DeDe Vecchio, a Harley rider from Asheville, North Carolina. Here is what DeDe has to say: \"I learned this recipe in the Black Hills Motorcycle Classic down at the Graveyard in 1984. First fry up some potatoes and onions. Maybe a little bacon if you want. You can add peppers, of course, and anything that is on sale at the local grocery store. Then break eggs on top and cook and stir in the pan. It's all mixed up and it tastes real good. I rode from Florida to Alaska, then back down to Sturgis on a 1964 Panhead hard tail. Loved it.\" Damn, Florida to Alaska to Sturgis on a rigid Panhead, that is really riding, so if DeDe says it tastes real good, you can take her word for it. How many of you could ride that far on a rigid?")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('table', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("¼")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("cup (½stick) butter")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("potatoes, peeled and diced")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("½")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("onion, diced")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("1")]), _c('br'), _c('b', [_vm._v("to")]), _c('br'), _c('b', [_vm._v("2")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("hot peppers, seeded and diced")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("Bacon (optional), cut into ½-inch pieces")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("6")]), _c('br'), _c('b', [_vm._v("to")]), _c('br'), _c('b', [_vm._v("7")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left",
      "valign": "top"
    }
  }, [_c('b', [_vm._v("large eggs, beaten")])])])]), _vm._v(" "), _c('p', {
    staticClass: "left"
  }, [_vm._v("In a large frying pan melt the butter over medium heat. Add the potatoes and onions and fry until the potatoes are tender and browned. Add the hot peppers and bacon, if using, and cook until the peppers are tender and the bacon is crisp. Add the eggs and stir until they are firm. Serve up hot.")]), _vm._v(" "), _c('p', {
    staticClass: "timebreak"
  }, [_c('br')]), _vm._v(" "), _c('p', {
    staticClass: "right"
  }, [_c('b', [_c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("FEEDS")]), _vm._v(" 4 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("HUNGRY BIKERS OR")]), _vm._v(" 5 "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("OL")]), _vm._v("' "), _c('span', {
    staticStyle: {
      "font-size": "smaller"
    }
  }, [_vm._v("LADIES")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26b8d63c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c003.vue
// module id = 87
// module chunks = 0